import Vue from 'vue';
import Vuex from 'vuex';

import layout from './layout';
import auth from './modules/auth';
import account from './modules/account';
import agent from './modules/agent';
import quarantine from './modules/quarantine';
import dashboard from './modules/dashboard';
import alert from './modules/alert';
import tenant from './modules/tenant';
import register from './modules/register';
import configuration from './modules/configuration';
import user from './modules/user';
import gestion from './modules/gestion';
import accounts from './modules/accounts';
import notification from './modules/notification'
import notificationPreferences from './modules/notificationPreferences'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    agent,
    account,
    dashboard,
    layout,
    quarantine,
    auth,
    tenant,
    register,
    configuration,
    user,
    alert,
    gestion,
    accounts,
    notification,
    notificationPreferences,
  },
});
